import { Box, Button, Grid, Paper, Stack, Typography, styled } from "@mui/material";
import GoogleMap from "../../maps/GoogleMap";
import GoogleMapMarker from "../../maps/GoogleMapMarker";
import { Link as RouterLink } from "react-router-dom";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { DebugBox, ReactHooksFormWrapper, TextAreaRequiredControl, TextFieldControl, hikoAlert } from "@northpowerdev/np-react-utils";
import { TextFieldAutoCompleteRequiredControl } from "../../form/TextFieldAutoCompleteControl";
import useFetchJson from "../../../data/useFetchJson";
import { MultiSelectCheckbox } from "../../styled/MultiSelectCheckbox";
const { Wrapper } = require("@googlemaps/react-wrapper");

const env = process.env.REACT_APP_ENV;
const envConfig = require(`../../../config/config.${env}.json`);

const markerLatLng = {lat: -35.7464, lng: 174.3094}
const initialZoom = 17

const defaultFormValues = {
    siteAddress: '',
    lotNumber: '',
    dpNumber: '',
    icpNumber: '',
    requestedInformationTypeList: [],
    scope: '',
}

const requestedInformationTypeOptions = [
  {value: 'GIS Cutout' ,        label: 'GIS Cutout'},
  {value: 'Cable Size',         label: 'Cable Size'},
  {value: 'Transformer Size',   label: 'Transformer Size'},
  {value: 'Other',              label: 'Other'},
]

const LocalStyledPaper = styled(Paper)(({theme}) => ({
    background: '#f1f3fa',
}));

const SummaryText = styled(Typography)(({theme}) => ({
    fontSize: '1.2em',
    fontWeight: 'bold',
}));

const StyledRouterLink = styled(RouterLink)(({theme}) => ({
    color: theme.palette.primary.main,
}));

export default function ConnectRequestForInformation() {

    const [zoom, setZoom]     = useState(initialZoom)
    const [center, setCenter] = useState({lat: markerLatLng.lat*1, lng: markerLatLng.lng*1})
    const [sentToNorthpower, setSentToNorthpower] = useState(false)
    const [googleMapsBounds, setGoogleMapsBounds] = useState() // Google LatLngBounds object
    const [markerPosition, setMarkerPosition] = useState({lat: markerLatLng.lat*1, lng: markerLatLng.lng*1})
    const [placeObject, setPlaceObject] = useState({}) // {addressComponents, geometry, formattedAddress, placeId}
    const [caseNumber, setCaseNumber] = useState()


    // console.log('ConnectRequestForInformation REFRESH')
    const { handleSubmit, formState: { errors }, watch, control } = useForm({defaultValues: defaultFormValues})
    const watchAllFields = watch()

    const rfiUrl = '/bff/salesforce-wrapper/api/partners/create-case/request-for-information'
    const {
        load: postRFI,
        isLoading: isRFIPosting,
        // data: postRFIResponse
        } = useFetchJson(rfiUrl, {method: 'POST'}, false)

    const render = (status) => {
        return <h4>Google Map: {status}</h4>
    }

    const onIdle = (m) => { // google.maps.Map
        const centerObject = m.getCenter()
        setZoom(m.getZoom())
        setCenter({lat: centerObject.lat(), lng: centerObject.lng()})
        setGoogleMapsBounds(m.getBounds())
    }

    const handleMarkerDragEnd = (position) => {
        console.log('handleMarkerDragEnd position', position.lat(), position.lng())
        setMarkerPosition({lat: position.lat(), lng: position.lng()})
    }

    const handleBringPinToCenter = () => {
        console.log('handleBringPinToCenter')
        setMarkerPosition({lat: center.lat, lng: center.lng})
    }

    const handleSelectAddress = (thePlaceObject) => {
        console.log('handleSelectAddress thePlaceObject', thePlaceObject)
        setPlaceObject(thePlaceObject)
        if (thePlaceObject?.geometry?.location) {
            const l = thePlaceObject.geometry.location
            setCenter({lat: l.lat(), lng: l.lng()})
            setMarkerPosition({lat: l.lat(), lng: l.lng()})
            setZoom(17)
        }
    }

    // const handleUsePlaceGeometry = (geometry) => {
    //     if (geometry?.location) {
    //         setCenter({lat: geometry.location.lat(), lng: geometry.location.lng()})
    //         setMarkerPosition({lat: geometry.location.lat(), lng: geometry.location.lng()})
    //         setZoom(17)
    //     }
    // }

    const onSubmit = async (data) => {
        // const northEastSoutWest = JSON.parse(googleMapsBounds.toJSON()) // E.g. {"south":-35.77425956409397,"west":174.21069470825196,"north":-35.71853068172461,"east":174.40810529174806}
        const postBody = mapFormData(data, placeObject, markerPosition, googleMapsBounds, center, zoom)
        console.log('ConnectRequestForInformation onSubmit passed validation with postBody', JSON.stringify(postBody))
        const options = {
            method: 'POST',
            headers: {},
            body: JSON.stringify(postBody),
        }
        let thePostRFIResponse
        try {
            thePostRFIResponse = await postRFI(options) // Succeeds with {caseId: "whatever"} or throws an error and displays a hikoAlert error message
            console.log("thePostRFIResponse: ", {postBody})
            if (thePostRFIResponse?.caseNumber) {
                hikoAlert('Thanks!', `Your request has been received by Northpower. Your new case id is ${thePostRFIResponse.caseNumber}.`, 'success')
                setCaseNumber(thePostRFIResponse.caseNumber)
                setSentToNorthpower(true) // postLiveningForm succeeds or throws error
            }
        } catch (e) {
            console.error(e)
            hikoAlert('There was a problem', 'We could not send your request to Northpower')
        }    
        console.log('ConnectRequestForInformation thePostRFIResponse', thePostRFIResponse)
    }

    if (sentToNorthpower) {
        console.log('CASE NUMBER: ',caseNumber)
        return (
            <Stack spacing={4} textAlign="center">
                <LocalStyledPaper sx={{ p: 2 }}>
                    <SummaryText sx={{ my: 1 }} variant="body1">All done.</SummaryText>
                    <Typography sx={{ mb: 2 }} >Your request has been received by Northpower.</Typography>
                    <Typography sx={{ mb: 2 }} >Your new case id is {caseNumber}</Typography>
                    <Box sx={{ my: 2 }}>
                        <StyledRouterLink to="/">Go To Mahi Home Page</StyledRouterLink>
                    </Box>
                    <StyledRouterLink to="/connect/request_for_information">New Request For Information</StyledRouterLink>
                </LocalStyledPaper>
            </Stack>
        )
    }

    return (
        <Box className="Page">

        <h2 className="np-title">Request For Information</h2>
        <Typography variant="body1">
            Tell us about your site.
        </Typography>

        <ReactHooksFormWrapper
                onSubmit={handleSubmit(onSubmit)}
                control={control}
                errors={errors}
                submitLabel="Send Request to Northpower"
                isSubmitting={isRFIPosting}
                submittingLabel="Sending Request..."
        >
        <Wrapper apiKey={envConfig.googleMapsAPIKey} render={render} libraries={['places']}>
            <Grid container sx={{mt:2}}>
                <Grid item xs={12} md={6} textAlign="left">
                    <Stack direction="column">
                            <TextFieldAutoCompleteRequiredControl
                                control={control}
                                errors={errors}
                                fieldName={'siteAddress'}
                                fieldLabel="Site Address"
                                onSelectAddress={handleSelectAddress}
                            />
                        </Stack>
                        {
                            placeObject?.addressComponents
                            &&
                            <>
                                <DebugBox title="addressFromAddressComponents" stringify>{addressFromAddressComponents(placeObject?.addressComponents)}</DebugBox>
                                <DebugBox title="addressComponents" stringify>{placeObject.addressComponents}</DebugBox>
                            </>
                        }
                    </Grid>
                    <Grid item xs={12} md={6} textAlign="left">
                        <Stack direction="row" justifyContent="flex-end">
                            {/* <Button
                                variant="outlined"
                                sx={{my:2, mx: 2}}
                                disabled={!placeObject?.geometry}
                                onClick={e => handleUsePlaceGeometry(placeObject?.geometry)}>Goto Address</Button> */}
                            <Button
                                variant="text"
                                sx={{my:2, mx: 2}}
                                onClick={handleBringPinToCenter}>Centre Marker</Button>
                        </Stack>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} textAlign="left">
                        <GoogleMap
                            center={center}
                            onIdle={onIdle}
                            zoom={zoom}
                            style={{ height: "400px" }}
                        >
                            {
                                markerLatLng
                                &&
                                <GoogleMapMarker key="m1" position={markerPosition} draggable={true} onDragEnd={handleMarkerDragEnd} />
                            }
                        </GoogleMap>

                        <Typography sx={{mt: 1}} variant="body2">
                            Move the map marker onto the site.
                            Zoom in so the site approximately fills the visible area.
                        </Typography>

                    </Grid>
                </Grid>
                <Grid container sx={{my:2}} spacing={4}>
                    <Grid item xs={12} md={6} textAlign="left">
                        <Stack direction="column">
                            <Box>
                                <TextFieldControl control={control} errors={errors} fieldName={'lotNumber'} fieldLabel="Lot Number" placeholder="E.g. 12" controlSx={{mr:2}} />
                                <TextFieldControl control={control} errors={errors} fieldName={'dpNumber'} fieldLabel="DP Number" placeholder="E.g. 172803" />
                            </Box>
                            <TextFieldControl control={control} errors={errors} fieldName={'icpNumber'} fieldLabel="ICP Number" placeholder="E.g. 575692 or 000575692NR820" />
                        </Stack>
                    </Grid>
                    <Grid item xs={12} md={6} textAlign="left">
                        <Stack direction="column">
                            <MultiSelectCheckbox 
                                control={control}
                                errors={errors}
                                fieldName={'requestedInformationTypeList'}
                                fieldLabel="Requested Information Type *"
                                options={requestedInformationTypeOptions}
                                checkboxHelperText='Select one or multiple options'
                                
                            />
                            <TextAreaRequiredControl
                                control={control}
                                errors={errors}
                                fieldName={'scope'}
                                fieldLabel='Overview of work'
                                placeholder="Please provide a description of the project / work"
                            />
                        </Stack>
                    </Grid>
                </Grid>

            </Wrapper>
            </ReactHooksFormWrapper>

            {
                center && zoom
                &&
                <DebugBox title="staticMap">{staticMapLinkFromMapLocation(center, zoom, markerPosition)}</DebugBox>
            }
            {
                placeObject?.addressComponents
                &&
                <>
                    <DebugBox title="addressFromAddressComponents" stringify>{addressFromAddressComponents(placeObject?.addressComponents)}</DebugBox>
                    <DebugBox title="addressComponents" stringify>{placeObject.addressComponents}</DebugBox>
                </>
            }
            <DebugBox title="placeObject" stringify>{placeObject}</DebugBox>
            <DebugBox title="watchAllFields" stringify>{watchAllFields}</DebugBox>
            <DebugBox title="googleMapsBounds" stringify>{googleMapsBounds}</DebugBox>
            <DebugBox title="markerPosition" stringify>{markerPosition}</DebugBox>
            </Box>
        )
}

/**
 * 
 * @param {object} data form fields
 * @param {object} placeObject {addressComponents, geometry, formattedAddress, placeId}
 * @param {object} markerLatLng  {lat, lng}
 * @param {object} mapBounds LatLngBounds
 * @param {object} center {lat, lng}
 * @param {number} zoom 
 * @returns 
 */
const mapFormData = (data, placeObject, markerLatLng, mapBounds, center, zoom) => {

    const serviceLocation = {
        // locationUnitNumber: null,
        // locationDairyNumber: null,
        // locationInformation: null,
        locationICPNumber: data?.icpNumber,
        locationLotNumber: data?.lotNumber,
        locationDPNumber: data?.dpNumber,
        // icpPremiseType: null,
        // legalDescription: null,
        geolocationLatitude: markerLatLng.lat,
        geolocationLongitude: markerLatLng.lng,
        mapBounds: mapBounds.toJSON(), // this object converts to "{north, east, south, west}" format.
    }

    const ac = placeObject?.addressComponents
    if (ac) {
        const {houseNumber, streetAddress, suburb, city, postcode} = addressFromAddressComponents(ac)
        serviceLocation.locationHouseNumber = houseNumber
        serviceLocation.locationStreetAddress = streetAddress
        serviceLocation.locationSuburb = suburb
        serviceLocation.locationCity = city
        serviceLocation.locationPostcode = postcode
    }

    if (ac) {
        serviceLocation.googleMaps = mapLinkFromGooglePlace(placeObject.geometry, placeObject.placeId)
    } else {
        serviceLocation.googleMaps = mapLinkFromMapLocation(center, zoom)
    }
    console.log('result.data: ',{data})
    const result = {
        serviceLocation,
        siteAddress: data.siteAddress, 
        requestedInfoTypes: data.requestedInformationTypeList,
        scopeOfWorks: data.scope
    }
    console.log('mapFormData result', result)
    return result
}

const addressComponentByType = (addressComponents, type) => {
    const matchedComponent = addressComponents.find(c => c.types.includes(type))
    return matchedComponent
}

const addressLongNameByType = (addressComponents, type) => {
    const matchedComponent = addressComponentByType(addressComponents, type)
    return matchedComponent?.long_name || ''
}

const addressFromAddressComponents = (ac) => {
    return {
        houseNumber: addressLongNameByType(ac, 'street_number'),
        streetAddress: addressLongNameByType(ac, 'route'),
        suburb: addressLongNameByType(ac, 'sublocality'),
        city: addressLongNameByType(ac, 'locality'),
        postcode: addressLongNameByType(ac, 'postal_code'),
    }
}

const mapLinkFromGooglePlace = (placeGeometry, placeId) => {
    console.log('mapLinkFromGooglePlace placeId', placeId)
    const mapBase = 'https://www.google.com/maps/search/?api=1'
    const query        = 'query='          + encodeLatLng(placeGeometry.location.lat(), placeGeometry.location.lng())
    const queryPlaceId = 'query_place_id=' + placeId
    const mapLink = `${mapBase}&${query}&${queryPlaceId}`
    return mapLink
}

const mapLinkFromMapLocation = (mapCenter, mapZoom) => {
    console.log('mapLinkFromMapLocation {mapCenter, mapZoom}', {mapCenter, mapZoom})
    const mapBase = 'https://www.google.com/maps/@?api=1&map_action=map'
    const center = 'center=' + encodeLatLng(mapCenter.lat, mapCenter.lng)
    const zoom   = 'zoom='   + mapZoom
    const mapLink = `${mapBase}&${center}&${zoom}`
    return mapLink
}

const staticMapLinkFromMapLocation = (mapCenter, mapZoom, mapMarkerPosition) => {
    // console.log('staticMapLinkFromMapLocation {mapCenter, mapZoom}', {mapCenter, mapZosom})

    //
    // See: https://developers.google.com/maps/documentation/maps-static/start
    //
    const mapBase = 'https://maps.googleapis.com/maps/api/staticmap?size=800x600&maptype=satellite'
    const center  = 'center=' + encodeLatLng(mapCenter.lat, mapCenter.lng)
    const zoom    = 'zoom='   + mapZoom
    const markers = 'markers=color:red%7C' + encodeLatLng(mapMarkerPosition.lat, mapMarkerPosition.lng) // %7C is an urlencoded '|' character
    const key     = 'key='    + envConfig.googleMapsAPIKey
    const mapLink = `${mapBase}&${center}&${zoom}&${markers}&${key}`
    return mapLink
}

const encodeLatLng = (lat, lng) => {
    return encodeURIComponent(`${lat},${lng}`)
}